import moment from "moment";

export const getRequestHeaders = (eventID, sessionID) => {
  return  {
    "Content-Type": "application/json",
    "WF-deliveryChannelType": "ECA",
    "WF-senderHostName": window.location.hostname,
    "WF-creationTimeStamp": moment.utc().format(),
    "WF-senderSubApplicationID": "ECA",
    "WF-senderMessageId": eventID,
    "X-APPCERT-MANUAL": "IGTWY",
    "Cache-Control": "no-cache",
    "WF-senderApplicationId": "ECA",
    "SessionID": sessionID
  };
};

export const getSwitchRequestHeaders = ({
  eventID,
  partner,
  sessionID,
  deviceIp,
  deviceType,
  senderHostName = window.location.hostname,
  deliveryChannelType = "ECA",
  senderApplicationId = "ECA",
  senderSubApplicationID = "ECA",
  creationTimestamp = moment().format("YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"),
}) => {
  return {
    "Content-Type": "application/json",
    "WF-deliveryChannelType": deliveryChannelType,
    "WF-senderHostName": senderHostName,
    "WF-creationTimeStamp": creationTimestamp,
    "WF-senderSubApplicationID": senderSubApplicationID,
    "WF-senderMessageId": eventID,
    "X-APPCERT-MANUAL": "IGTWY",
    "Cache-Control": "no-cache",
    "WF-senderApplicationId": senderApplicationId,
    Partner: partner,
    SessionID: sessionID,
    DeviceIP: deviceIp,
    DeviceType: deviceType,
  };
};

export const getCardConfirmationRequestHeaders = (eventID, sessionID, deviceIp, deviceType) => {
    return   {
    "Content-Type": "application/json",
    //"WF-deliveryChannelType": "ECA",
    "WF-senderHostName": window.location.hostname,
    "WF-creationTimeStamp": moment().format("YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"),
    "WF-senderSubApplicationID": "ECA",
    "WF-senderMessageId": eventID,
    "X-APPCERT-MANUAL": "IGTWY",
    "Cache-Control": "no-cache",
    "WF-senderApplicationId": "ECA",
    "SessionID": sessionID,
    "DeviceIP": deviceIp,
    "DeviceType": deviceType
  };
};
